export default __webpack_public_path__ + "3bdf6cf5a5614bea834f2f2ade5240ab.png";